import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import cogoToast from 'cogo-toast';
import { addDays, format } from 'date-fns';
import debounce from 'lodash/debounce';
import { BsAirplane } from 'react-icons/bs';
import { LiaExchangeAltSolid } from 'react-icons/lia';
import { LuClock } from 'react-icons/lu';
import { Spinner } from 'reactstrap';
import {
  GET_AIRPORTS_BASED_ON_CONFIG_ID,
  GET_AUTOCOMPLETE_LOCATION,
  GET_AUTOCOMPLETE_LOCATION_EMPTY,
  GET_RECENT_SEARCHES,
  VALIDATE_LOCATION,
} from '../../../../../../../../store/actions';
import DateTimePicker from '../time';

export default function LocationDetailsForm({
  selectedConfig,
  locationDetails,
  setLocationDetails,
  configId,
  randomUUID,
  selectedUser,
  currentActiveForm,
  setCurrentActiveForm,
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  allDates,
  allTimes,
}) {
  const dispatch = useDispatch();

  const pickupRef = useRef<HTMLInputElement>(null);
  const dropRef = useRef<HTMLInputElement>(null);

  const [currentActiveInput, setCurrentActiveInput] = useState('pickUp');

  const [typedPickup, setTypedPickup] = useState('');
  const [typedDrop, setTypedDrop] = useState('');

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { resentSearchesRes, resentSearchesResLoading } = useSelector((state: any) => ({
    resentSearchesRes: state?.GetRecentSearches?.data,
    resentSearchesResLoading: state?.GetRecentSearches?.loading,
  }));

  const { airportsList, airportsListLoading } = useSelector((state: any) => ({
    airportsList: state?.GetAirportsBasedOnConfig?.data,
    airportsListLoading: state?.GetAirportsBasedOnConfig?.loading,
  }));

  const { validateLocationRes, validateLocationLoading } = useSelector((state: any) => ({
    validateLocationRes: state?.GetValidateLocation?.data,
    validateLocationLoading: state?.GetValidateLocation?.loading,
  }));

  const { autoCompleteRes, autoCompleteResLoading } = useSelector((state: any) => ({
    autoCompleteRes: state?.getAutoCompleteLocation?.data,
    autoCompleteResLoading: state?.getAutoCompleteLocation?.loading,
  }));

  useEffect(() => {
    if (validateLocationRes) {
      if (validateLocationRes?.result?.to?.error_message || validateLocationRes?.result?.from?.error_message) {
        cogoToast.error(`${validateLocationRes?.result?.to?.error_message || validateLocationRes?.result?.from?.error_message}`);
        setCurrentActiveForm(1);
      } else {
        setLocationDetails(validateLocationRes?.result);
        setTypedPickup(validateLocationRes?.result?.from?.name);
        setTypedDrop(validateLocationRes?.result?.to?.name);

        if (currentActiveInput === `pickUp`) {
          dropRef.current.focus();
        }

        if (validateLocationRes?.result?.from?.place_id && validateLocationRes?.result?.to?.place_id) {
          setCurrentActiveForm(2);
        }
      }

      dispatch({
        type: GET_AUTOCOMPLETE_LOCATION_EMPTY,
      });
    }
  }, [validateLocationRes]);

  useEffect(() => {
    pickupRef.current.focus();
  }, []);

  useEffect(() => {
    if (configId) {
      dispatch({
        type: GET_RECENT_SEARCHES,
        payload: {
          urlParams: {
            benefit_config_id: configId,
          },
        },
      });

      dispatch({
        type: GET_AIRPORTS_BASED_ON_CONFIG_ID,
        payload: {
          urlParams: {
            benefitConfigId: configId,
          },
        },
      });
    }
  }, [configId]);

  const validateLocationHandler = (data: any) => {
    let payloadData = {};

    if (currentActiveInput === `pickUp`) {
      if ((locationDetails?.to?.name || '')?.trim() === ``) {
        payloadData = {
          from: {
            key: `${data?.name}`,
            place_id: `${data?.place_id}`,
          },
        };
      } else {
        payloadData = {
          to: {
            key: `${locationDetails?.to?.name}`,
            place_id: `${locationDetails?.to?.place_id}`,
          },
          from: {
            key: `${data?.name}`,
            place_id: `${data?.place_id}`,
          },
        };
      }
    } else if (currentActiveInput === `drop`) {
      if ((locationDetails?.from?.name || '')?.trim() === ``) {
        payloadData = {
          to: {
            key: `${data?.name}`,
            place_id: `${data?.place_id}`,
          },
        };
      } else {
        payloadData = {
          to: {
            key: `${data?.name}`,
            place_id: `${data?.place_id}`,
          },

          from: {
            key: `${locationDetails?.from?.name}`,
            place_id: `${locationDetails?.from?.place_id}`,
          },
        };
      }
    }
    dispatch({
      type: VALIDATE_LOCATION,
      payload: {
        data: {
          benefit_groupConfig_id: configId,
          search_request: {
            ...payloadData,
          },
        },
      },
    });
  };

  const callLocationAutoCompleteApi = async (searchValue: string) => {
    dispatch({
      type: GET_AUTOCOMPLETE_LOCATION,
      payload: {
        urlParams: {
          input: searchValue,
          sessionToken: randomUUID,
        },
      },
    });
  };

  const swapHandler = () => {
    if (locationDetails?.to?.place_id || locationDetails?.from?.place_id) {
      setLocationDetails(validateLocationRes?.result);

      dispatch({
        type: VALIDATE_LOCATION,
        payload: {
          data: {
            benefit_groupConfig_id: configId,
            search_request: {
              from: {
                place_id: `${locationDetails?.to?.place_id}`,
                name: `${locationDetails?.to?.name}`,
              },
              to: {
                place_id: `${locationDetails?.from?.place_id}`,
                name: `${locationDetails?.from?.name}`,
              },
            },
          },
        },
      });
    }
  };

  const debouncedApiCall = useCallback(
    debounce((locationValue: string) => {
      if (locationValue.length > 3) {
        callLocationAutoCompleteApi(locationValue);
      }
    }, 1000),
    [],
  );

  // useEffect(() => {
  //   if (selectedConfig) {
  //     dateTimeCalculation(selectedConfig);
  //   }
  // }, [selectedConfig]);

  console.log('selecteeed', selectedDate, selectedTime);

  return (
    <div className="form-section-location-details">
      <h4>Your Route</h4>
      <div className="search-box-wrapper">
        <div className="search-box-container">
          <div className="pickup-location-txt-container">
            <div className="pickup-dot"></div>
            <input
              type="text"
              className="pickup-location-txt-box"
              placeholder="Pickup Location"
              ref={pickupRef}
              onFocus={() => {
                setCurrentActiveInput('pickUp');
              }}
              onChange={(e: any) => {
                const searchValue = e.target.value;
                setTypedPickup(e.target.value);

                if (searchValue.trim()) {
                  debouncedApiCall(searchValue.trim());
                }
              }}
              value={typedPickup}
              disabled={currentActiveForm === 2}
            />

            {/* {validateLocationLoading && currentActiveInput === `pickUp` && (
              <div className="field-loader">
                <Spinner color="primary" size="sm" />
              </div>
            )} */}
          </div>
          <div className="drop-location-txt-container">
            <div className="drop-dot"></div>
            <input
              type="text"
              className="drop-location-txt-box"
              placeholder="Drop Location"
              ref={dropRef}
              onFocus={() => {
                setCurrentActiveInput('drop');
              }}
              onChange={(e: any) => {
                const searchValue = e.target.value;
                setTypedDrop(e.target.value);

                if (searchValue.trim()) {
                  debouncedApiCall(searchValue.trim());
                }
              }}
              value={typedDrop}
              disabled={currentActiveForm === 2}
            />

            {/* {validateLocationLoading && currentActiveInput === `drop` && (
              <div className="field-loader">
                <Spinner color="primary" size="sm" />
              </div>
            )} */}
          </div>

          <div className="dashed-line"></div>
          {currentActiveForm === 1 && (
            <>
              {(validateLocationLoading && currentActiveInput === `drop`) || (validateLocationLoading && currentActiveInput === `pickUp`) ? (
                <>
                  <div className="swap-location">
                    <span className="swap-icon">
                      <Spinner color="white" size="sm" />
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="swap-location" onClick={swapHandler}>
                    <span className="swap-icon">
                      <LiaExchangeAltSolid />
                    </span>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {currentActiveForm === 1 && (
        <>
          {autoCompleteResLoading && (
            <div className="search-field-loader">
              <Spinner color="primary" size="sm" />
            </div>
          )}

          <div className="scroll-container">
            {autoCompleteRes?.predictions?.length > 0 && (
              <div className="search-result-container">
                <div className="search-section-label">Search Results</div>
                <div className="result-wrapper">
                  {autoCompleteRes?.predictions?.map(prediction => (
                    <div
                      className="search-result"
                      onClick={() => {
                        validateLocationHandler({ ...prediction, name: prediction?.structured_formatting?.main_text });
                      }}
                    >
                      <div className="result-icon">
                        <div className="timer-icon">
                          <LuClock />
                        </div>
                      </div>
                      <div className="searched-result">
                        <div className="primary-text">{prediction?.structured_formatting?.main_text ?? ''}</div>
                        <div className="secondary-text">{prediction?.structured_formatting?.secondary_text ?? ''}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {!autoCompleteRes?.predictions && resentSearchesRes?.result?.length > 0 && (
              <div className="search-result-container">
                <div className="search-section-label">Recent Search</div>
                <div className="result-wrapper">
                  {resentSearchesRes?.result?.map(resentSearches => (
                    <div
                      className="search-result"
                      onClick={() => {
                        validateLocationHandler({ ...resentSearches, place_id: resentSearches.placeId });
                      }}
                    >
                      <div className="result-icon">
                        <div className="timer-icon">
                          <LuClock />
                        </div>
                      </div>
                      <div className="searched-result">
                        <div className="primary-text">{resentSearches?.name ?? ''}</div>
                        <div className="secondary-text">
                          {[resentSearches?.subRegion, resentSearches?.region]
                            .map(s => s?.trim())
                            .filter(Boolean)
                            .join(', ')}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {!autoCompleteRes?.predictions && (selectedUser?.addresses ?? [])?.filter(address => address?.placeId)?.length > 0 && (
              <div className="search-result-container">
                <div className="search-section-label">Saved Addresses</div>
                <div className="result-wrapper">
                  {(selectedUser?.addresses ?? [])
                    ?.filter(address => address?.placeId)
                    ?.map(address => (
                      <div
                        className="search-result"
                        onClick={() => {
                          validateLocationHandler({ ...address, place_id: address?.placeId });
                        }}
                      >
                        <div className="result-icon">
                          <div className="timer-icon">
                            <LuClock />
                          </div>
                        </div>
                        <div className="searched-result">
                          <div className="primary-text">{address?.nickname ?? ''}</div>
                          <div className="secondary-text">
                            {[address?.streetAddress, address?.subRegion, address?.region]
                              .map(s => s?.trim())
                              .filter(Boolean)
                              .join(', ')}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {!autoCompleteRes?.predictions && airportsList?.results?.length > 0 && (
              <div className="search-result-container">
                <div className="search-section-label">Servicable Airports</div>
                <div className="result-wrapper">
                  {airportsList?.results?.map((airports, index) => (
                    <div
                      className="search-result"
                      onClick={() => {
                        validateLocationHandler({ ...airports, place_id: airports?.placeId });
                      }}
                    >
                      <div className="result-icon">
                        <div className="timer-icon servicable-airports">
                          <BsAirplane />
                        </div>
                      </div>
                      <div className="searched-result">
                        <div className="primary-text">{airports?.name ?? ''}</div>
                        <div className="secondary-text">{airports?.address ?? ''}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {currentActiveForm === 2 && (
        <div className="time-text-container">
          <DateTimePicker
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            datesArray={allDates}
            timesArray={allTimes}
          />
        </div>
      )}

      {currentActiveForm === 2 && (
        <div className={`stepper-form-footer-btn`} style={{ marginTop: '40px' }}>
          <div
            className="stepper-form-footer-btn-secondary"
            onClick={() => {
              setCurrentActiveForm(1);
              dispatch({
                type: VALIDATE_LOCATION,
                payload: {
                  data: {
                    benefit_groupConfig_id: configId,
                    search_request: {
                      from: {
                        place_id: `${locationDetails?.from?.place_id}`,
                        name: `${locationDetails?.from?.name}`,
                      },
                    },
                  },
                },
              });
            }}
          >
            Previous
          </div>
          <div
            className="stepper-form-footer-btn-primary"
            onClick={() => {
              setCurrentActiveForm(3);
            }}
          >
            Continue
          </div>
        </div>
      )}
    </div>
  );
}
